import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createPublicUpdateReducer, createUpdateReducer } from '@ff-os/pdp-shared-redux/createUpdateReducer';
import { GiftSceneMeta } from '@ff-scene-plugins/gift-shared/GiftSceneMeta';
import { GiftPdpState } from '../store';

const { actions, reducer } = createSlice({

    name: 'meta',

    initialState: { public: {} } as GiftSceneMeta,

    reducers: {

        overwrite: (state, action: PayloadAction<any>) => {
            return action.payload;
        },

        updateItem: createUpdateReducer<GiftSceneMeta>(),

        updatePublicItem: createPublicUpdateReducer<GiftSceneMeta>()
    }
});

export const createMetaBindings = () => ({

    createMetaSelector: <T>(selector: (meta: GiftSceneMeta) => T) => createSelector(
        (state: GiftPdpState) => state.project.meta,
        o => selector(o)),

    createMetaUpdateAction: <TKey extends keyof GiftSceneMeta>(key: TKey) =>
        (value: GiftSceneMeta[TKey]) => actions.updateItem({ key, value }),

    createPublicMetaSelector: <T>(selector: (meta: GiftSceneMeta['public']) => T) => createSelector(
        (state: GiftPdpState) => state.project.meta,
        o => selector(o.public)),

    /**
     * NOTE: Any item set in public meta will be visible to tenants via the output API.
     */
    createPublicMetaUpdateAction: <TKey extends keyof GiftSceneMeta['public']>(key: TKey) =>
        (value: GiftSceneMeta['public'][TKey]) => actions.updatePublicItem({ key, value })
});

export { reducer, actions };